export default __webpack_public_path__ + "static/media/BOWire1.4e27bec8.png";